// migrate to functional component
import React from 'react';
import { Route, Routes } from 'react-router-dom';


import styled from 'styled-components';
import { PatientProvider } from './hooks/Context/PatientProvider';
// import { stringify } from 'querystring';
import AppRoutes from './AppRoutes';
const Container = styled.div`
width: 100%;

`;

fetch('weatherforecast')
  .then(response => response.json())
  .then(data => console.log(data));

// fetch('api/agenda')
//   .then(response => response.json())
//   .then(data => console.log(data));


const App = (): JSX.Element => {
  return (
    <Container>

      <PatientProvider>
        <Routes>
          {AppRoutes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes>
      </PatientProvider>

    </Container>
  );
}

export default App;

